import i18n from '../../i18n';

// Formatação das métricas no idioma ativo (pt → 1.234,5; en → 1,234.5).
const locale = () => i18n.language || 'pt';

export const formatNumber = (value, maximumFractionDigits = 0) =>
  value == null ? '—' : new Intl.NumberFormat(locale(), { maximumFractionDigits }).format(value);

// `value` já em 0–100 (ex.: ai_resolution_rate).
export const formatPercent = (value, maximumFractionDigits = 1) =>
  value == null
    ? '—'
    : new Intl.NumberFormat(locale(), { style: 'percent', maximumFractionDigits }).format(value / 100);

// Número curto para eixos: 12500 → "12,5 mil" (pt) / "12.5K" (en).
export const formatCompactNumber = (value) =>
  value == null
    ? '—'
    : new Intl.NumberFormat(locale(), { notation: 'compact', maximumFractionDigits: 1 }).format(value);

// Fração de `value` sobre `total`, em 0–100 (0 quando não há total).
export const percentOf = (value, total) => (total ? (value / total) * 100 : 0);

// Segundos → "45s", "3min 20s", "2h 5min", "1d 4h". Null → "—".
export const formatDuration = (seconds) => {
  if (seconds == null) return '—';
  const s = Math.round(seconds);
  if (s < 60) return `${s}s`;
  const minutes = Math.floor(s / 60);
  if (minutes < 60) {
    const rest = s % 60;
    return rest ? `${minutes}min ${rest}s` : `${minutes}min`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rest = minutes % 60;
    return rest ? `${hours}h ${rest}min` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const rest = hours % 24;
  return rest ? `${days}d ${rest}h` : `${days}d`;
};

// Milissegundos → "850ms" abaixo de 1s, senão o mesmo formato de formatDuration.
export const formatMilliseconds = (ms) => {
  if (ms == null) return '—';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  if (ms < 60000) return `${formatNumber(ms / 1000, 1)}s`;
  return formatDuration(ms / 1000);
};

// 'yyyy-MM-dd' (data local, sem fuso) → data curta no idioma ativo.
export const formatDate = (value) =>
  value ? new Intl.DateTimeFormat(locale(), { dateStyle: 'short' }).format(new Date(`${value}T00:00:00`)) : '—';

export const formatDateTime = (value) =>
  value
    ? new Intl.DateTimeFormat(locale(), { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value))
    : '—';

// Soma dos valores de um objeto { chave: número }.
export const sumValues = (dict) => Object.values(dict ?? {}).reduce((sum, value) => sum + (value || 0), 0);

/**
 * Fatias de uma rosca por grupo (origem, departamento…): os `max - 1` maiores
 * grupos com cor própria da paleta de séries, o resto somado em "Outras".
 * `rows`: [{ key, label, value }] já em ordem decrescente.
 */
export const toSeriesSlices = (rows, { max = 7, othersLabel, colors }) => {
  const shown = rows.length > max ? rows.slice(0, max - 1) : rows;
  const others = rows.slice(shown.length).reduce((sum, row) => sum + row.value, 0);
  const slices = shown.map((row, index) => ({ ...row, color: colors[index % colors.length] }));
  if (others) slices.push({ key: '__others__', label: othersLabel, value: others, color: 'text.secondary' });
  return slices;
};
